/* Do not remove this code. */
function reloadImg2978441000000331009() {
  var captcha = document.getElementById("imgid2978441000000331009");
  if (captcha.src.indexOf("&d") !== -1) {
    captcha.src =
      captcha.src.substring(0, captcha.src.indexOf("&d")) +
      "&d" +
      new Date().getTime();
  } else {
    captcha.src = captcha.src + "&d" + new Date().getTime();
  }
}

function checkMandatory2978441000000331009() {
  var mndFileds = new Array("Email", "LEADCF1");
  var fldLangVal = new Array("Last\x20Name", "Email_News", "Country\x20\x2D");
  for (i = 0; i < mndFileds.length; i++) {
    var fieldObj =
      document.forms["WebToLeads2978441000000331009"][mndFileds[i]];
    if (fieldObj) {
      if (fieldObj.value.replace(/^\s+|\s+$/g, "").length == 0) {
        if (fieldObj.type == "file") {
          alert("Please select a file to upload.");
          fieldObj.focus();
          return false;
        }
        alert(fldLangVal[i] + " cannot be empty.");
        fieldObj.focus();
        return false;
      } else if (fieldObj.nodeName == "SELECT") {
        if (fieldObj.options[fieldObj.selectedIndex].value == "-None-") {
          alert(fldLangVal[i] + " cannot be none.");
          fieldObj.focus();
          return false;
        }
      } else if (fieldObj.type == "checkbox") {
        if (fieldObj.checked == false) {
          alert("Please accept  " + fldLangVal[i]);
          fieldObj.focus();
          return false;
        }
      }
      try {
        if (fieldObj.name == "Last Name") {
          name = fieldObj.value;
        }
      } catch (e) {}
    }
  }
  trackVisitor();
  var urlparams = new URLSearchParams(window.location.search);
  if (urlparams.has("service") && urlparams.get("service") === "smarturl") {
    var webform = document.getElementById("webform");
    var service = urlparams.get("service");
    var smarturlfield = document.createElement("input");
    smarturlfield.setAttribute("type", "hidden");
    smarturlfield.setAttribute("value", service);
    smarturlfield.setAttribute("name", "service");
    webform.appendChild(smarturlfield);
  }
  document
    .querySelector(".crmWebToEntityForm .formsubmit")
    .setAttribute("disabled", true);
}

function tooltipShow2978441000000331009(el) {
  var tooltip = el.nextElementSibling;
  var tooltipDisplay = tooltip.style.display;
  if (tooltipDisplay == "none") {
    var allTooltip = document.getElementsByClassName("zcwf_tooltip_over");
    for (i = 0; i < allTooltip.length; i++) {
      allTooltip[i].style.display = "none";
    }
    tooltip.style.display = "block";
  } else {
    tooltip.style.display = "none";
  }
}
